import approx from 'approximate-number';
import LikeIcon from '@mui/icons-material/FavoriteBorder';
import LikedIcon from '@mui/icons-material/Favorite';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import FlatButton from 'components/FlatButton';
import { colors } from '@mui/material';

const LikeButton = ({ liked, likes, ...props }) => (
  <FlatButton
    {...props}
    forceLabel
    icon={useMemo(
      () => (liked ? (
        <LikedIcon htmlColor={colors.red[500]} />
        ) : (
          <LikeIcon htmlColor='#fff' />
        )),
      [liked],
    )}
    label={useMemo(() => approx(likes || 0), [likes])}
    title='Likes'
    lableColor={liked ? colors.red[500] : '#fff'}
  />
);

LikeButton.propTypes = {
  ...FlatButton.propTypes,
  liked: PropTypes.bool.isRequired,
  likes: PropTypes.number.isRequired,
};

export default LikeButton;
